<template>
  <section class="form-section">
    <header class="form-section__header">
      <h1 class="form-section__title">
        {{ title }}
        <Hint v-if="hint" :message="hint" />
      </h1>
      <div class="form-section__header-divider" />
      <button
        v-if="hasEdit"
        v-show="!isEditMode"
        class="form-section__action-btn"
        @click.prevent="onEdit"
      >
        <i class="el-icon-edit form-section__action-btn-icon" />
        <span class="form-section__edit-title">
          {{ $t('EDIT') }}
        </span>
      </button>
    </header>
    <div class="row align-justify" :class="dynamicLayoutClasses">
      <template v-if="description">
        <div class="small-12 columns" :class="dynamicLayoutClasses">
          <p
            v-dompurify-html="description"
            class="form-section__description"
            :style="{ color: colorDescription || 'rgba(0, 0, 0, 0.4)' }"
          />
        </div>
        <div class="small-12 large-expand columns">
          <slot />
        </div>
      </template>
      <slot v-else />
    </div>
  </section>
</template>

<script>
import Hint from '@@/common/Hint';

export default {
  name: 'FormSection',
  components: {
    Hint,
  },
  model: {
    prop: 'isEditMode',
    event: 'edit',
  },
  props: {
    title: {
      type: String,
      default: '',
    },
    description: {
      type: String,
      default: '',
    },
    hasEdit: {
      type: Boolean,
      default: false,
    },
    isEditMode: {
      type: Boolean,
      default: false,
    },
    hint: {
      type: String,
      default: '',
    },
    colorDescription: {
      type: String,
      default: '',
    },
    descriptionPosition: {
      type: String,
      default: 'side',
      validator(value) {
        const validValues = ['side', 'top'];
        return validValues.includes(value);
      },
    },
  },
  computed: {
    shouldBeFullWidth() {
      return this.descriptionPosition === 'top' || !this.description;
    },
    dynamicLayoutClasses() {
      return {
        'flex-dir-column': this.shouldBeFullWidth,
        'large-5': !this.shouldBeFullWidth,
      };
    },
  },
  methods: {
    onEdit() {
      this.$emit('edit', true);
    },
  },
};
</script>
<style lang="scss" scoped>
.form-section {
  &__header {
    display: flex;
  }

  &__title {
    /* Typography */
    font-size: rem-calc(24);
    font-weight: 300;
  }

  &__description {
    /* Box Model */
    margin-top: $global-margin * $lb-small-size-factor;
    margin-bottom: $global-margin * $lb-small-size-factor;

    @include breakpoint(large) {
      margin-top: $global-margin;
      margin-bottom: $global-margin;
    }
  }

  &__header-divider {
    flex: 1;
  }

  &__button {
    margin-top: $global-margin;
  }

  &__action-btn {
    // to override old global style
    position: static;
    // end

    cursor: pointer;

    vertical-align: bottom;
    font-size: rem-calc(14.4);
    font-weight: 300;
    color: $wet-asphalt;
    outline: none;

    &-icon {
      font-size: 80%;

      transform: scaleX(-1);

      @include rtl() {
        transform: none;
      }
    }

    @include rtl() {
      right: auto;
      left: 0;
    }
  }

  .flex-dir-column .columns.large-expand {
    padding: 0;
  }
}
</style>
